import { legacy_createStore, combineReducers } from "redux";
import UserService from "../services/user.service";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";

const types = {
  SET_AUTH_STATE: "SET_AUTH_STATE",
  INIT_AUTH_STATE: "INIT_AUTH_STATE",
  SET_SSO_STATE: "SET_SSO_STATE",
  INIT_SSO_STATE: "INIT_SSO_STATE",
};

let AUTH_STATE = "IQVIA_AUTH_STATE";
if(SPAIN){
  AUTH_STATE = "IQVIA_SPAIN_AUTH_STATE";
} else if(SAUDI){
  AUTH_STATE = "IQVIA_SAUDI_AUTH_STATE";
}

const initialAuthState = {
  authToken: "",
  isLoggedIn: false,
  user: {},
};

const auth_reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case types.SET_AUTH_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case types.INIT_AUTH_STATE:
      return {
        ...initialAuthState,
      };
    default:
      return state;
  }
};

const initialSsoState = {};

const sso_reducer = (state = initialSsoState, action) => {
  switch (action.type) {
    case types.SET_SSO_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case types.INIT_SSO_STATE:
      return {
        ...initialSsoState,
      };
    default:
      return state;
  }
};

const store = legacy_createStore(
  combineReducers({ auth_reducer, sso_reducer }),
  /* preloadedState, */ window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

(function initAuthStore() {
  const localAuthState = localStorage.getItem(AUTH_STATE) ? JSON.parse(localStorage.getItem(AUTH_STATE)) : "";

  if (localAuthState) {
    store.dispatch({
      type: types.SET_AUTH_STATE,
      payload: localAuthState,
    });
    userProfile();
  } else {
    store.dispatch({
      type: types.INIT_AUTH_STATE,
    });
  }
})();

async function userProfile(dispatch = store.dispatch) {
  try {
    const resp = await UserService.profile();
    if (resp.data && resp.data.success) {
      const payload = {
        isLoggedIn: true,
        user: resp.data.data,
      };
      dispatch({ type: types.SET_AUTH_STATE, payload });
    } else {
      dispatch({ type: types.INIT_AUTH_STATE });
      removeAuthStorage();
    }
  } catch (err) {
    console.error("User Profile error catch => ", err);
  }
}

function setAuthStorage() {
  localStorage.setItem(AUTH_STATE, JSON.stringify({ authToken: store.getState().auth_reducer.authToken }));
}

function removeAuthStorage() {
  if (localStorage.getItem(AUTH_STATE)) localStorage.removeItem(AUTH_STATE);
}

const actions = {
  userProfile,
  setAuthStorage,
  removeAuthStorage,
};

export { store as default };
export { types, actions };
